import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JobImageService {
  private jobImagesSource = [
    "job001.jpg",
    "job002.jpg",
    "job003.jpg",
    // "job004.jpg",
    // "job005.jpg",
    "job006.jpg",
    "job007.jpg",
    "job008.jpg",
    "job009.jpg",
    "job010.jpg",
    "job011.jpg",
    "job012.jpg",
    "job013.jpg",
    "job014.jpg",
    "job015.jpg",
    "job016.jpg",
    "job017.jpg",
    "job018.jpg",
    "job019.jpg",
    "job020.jpg",
    "job021.jpg",
    "job022.jpg",
    "job023.jpg",
    "job024.jpg",
    "job025.jpg",
    "job026.jpg",
    "job027.jpg"
  ];

  private jobImages:any;
  constructor() { 
    this.generateRandomImages();
  }

  generateRandomImages(){    
    this.jobImages = JSON.parse(JSON.stringify(this.jobImagesSource));
    this.jobImages = this.shuffleJobImages(this.jobImages);
  }

  getJobImage(){
    if(this.jobImages.length === 0){
      this.generateRandomImages();
    }
    return this.jobImages.pop();
  }

  private shuffleJobImages(array: any[]) {
    let currentIndex = array.length;
    let randomIndex;
  
    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
  
    return array;
  }
}
